export function getView(state) {
  return state === 'SCHEDULED' ? 'CheckIn' : 'Schedule'
}
